<template>
  <div class="body">
    <!-- 使用 TopNav 组件 -->
    <TopNav />

    <div class="page">
      <div class="img1"><img src="@/assets/代表工程/咸九高速.jpeg" alt="">
        <div class="img1title">咸九高速</div></div>
      <div class="mode">
        <div class="mode1">
          <div class="modetitle">
            <div class="gang"></div>
            <span>联系我们</span>
            <div class="gang"></div>
          </div>
          <div class="modepage">
            <div class="pagetitle">
              <div class="pagetitle1">
                <h3>公司总部</h3>
              <div>地址：湖北省葛店开发区1号工业园区创业北路</div>
                <div>电话：0711-5110162</div>
              </div>
              <div class="pagetitle1">
                <h3>荆门分部</h3>
                <div>荆门分公司地址：荆门市掇刀区荆东大道343号（荆门化工循环产业园）</div>
                <div>荆门分公司电话：0724-2290301</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <FootIndex></FootIndex>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav.vue' // 引入 TopNav 组件
import FootIndex from '@/components/FootIndex.vue'

export default {
  name: 'EngineeringIndex',
  components: {
    TopNav, // 注册 TopNav 组件
    FootIndex
  }
}
</script>

<style lang="less" scoped>
.body {
  display: grid;
  grid-template-rows: 66px auto; /* 第一行是 nav 的高度，第二行是剩余空间 */
  height: 100vh;
}

.page{
  padding-top: 100px;
}

.img1 {
  width: 100%;
  height: 400px;
  min-width: 1000px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.img1 img{
  width: 100%;
  min-width: 1200px;
  object-fit: cover; /* 图片填充容器，保持比例 */
  object-position: center; /* 图片居中 */
  position: relative;
}

.img1title{
  position: absolute;
  bottom: 40px; /* 放置在底部 */
  left: 50%; /* 水平居中 */
  transform: translateX(-50%); /* 水平居中 */
  background-color: rgba(8, 105, 231, 0.558); /* 背景色 */
  color: white; /* 文字颜色 */
  padding: 4px 0px; /* 内边距 */
  border-radius: 5px; /* 圆角 */
  z-index: 1;
  width: 40%;
}

.img {
  background-color: pink;
  height: 182px;
}

.modetitle {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
}

.modetitle span {
  font-size: 30px;
    padding-top: 0px;
    font-weight: bold;
    font-family: SimSun;
  color: #000;
  margin: 0 6px 0px 6px;
}
.gang {
  display: block;
  background: rgb(198, 198, 198);
  width: 1rem;
  height: 0.062rem;
  border-radius: inherit;
}

.modepage {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.pagetitle{
  height: 80vh;
  padding: 20px 20px;
  line-height: 1.5;
}

.pagetitle h3{
  font-size: 18px;
  color: #004da0;
}

.pagetitle1:nth-child(2){
  margin-top: 80px;
}

.modeimg {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 350px;
  height: 220px;
  overflow: hidden;
  border-radius: 20px;
}

.modeimg img {
  width: 350px;
}

.jianjie {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 350px;
  text-indent: 2em;
}

.jianjie p {
  font-size: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  line-clamp: 6;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 2;
}

.contact {
  margin-top: 20px;
  width: 353px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.conimg {
  width: 353px;
  overflow: hidden; /* 隐藏超出部分 */
}

.conimg img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持比例，覆盖整个盒子 */
  object-position: center; /* 从中间开始对齐 */
}

.conitem {
  width: 100%;
  height: 78px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  background-color: rgb(237, 235, 235);
}
</style>
